import { useMutation } from "@tanstack/react-query";
import { addOrUpdateTag, TagPayload } from "PFCore/services/activities/tags";
import { Id } from "PFTypes";
import { MutationOptions } from "PFTypes/request_options";

import { useActivityInvalidate } from "../../activity";

type Payload = { activityId: Id; tagPayload: TagPayload };

export const useCreateTag = (options: MutationOptions<Payload> = {}) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();

  return useMutation({
    mutationFn: ({ activityId, tagPayload }: { activityId: Id; tagPayload: TagPayload }) =>
      addOrUpdateTag(activityId, tagPayload),
    ...options,
    onSuccess: (...args) => {
      const { activityId } = args[1];

      invalidateActivity([activityId]);
      options?.onSuccess?.(...args);
    }
  });
};
